var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"ma-4",attrs:{"sentry-tag":"settings-debug.button.removeDemoUsers"},on:{"click":_vm.hubspotCreateContact}},[_vm._v(" Test contact ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }